'use client'

import { useGetProjectId } from '@/app/slugs'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from '@/shared/ui/use-toast'
import { UpdateProjectBriefAnswerPayload } from '../../lib'
import services from '../services'

const useUpdateProjectBriefAnswer = () => {
  const { projectId } = useGetProjectId()
  const queryClient = useQueryClient()
  const briefAnswersQueryKey = [queryKeys((a, m) => a.project.getProjectBriefAnswers({ projectId }) + m.get)]

  return useMutation({
    mutationKey: [queryKeys((a, m) => a.project.updateProjectBriefAnswer({ answerId: 0 }) + m.patch)],
    mutationFn: async (payload: { answerId: number } & UpdateProjectBriefAnswerPayload) =>
      apiResponseHandler(await services.updateProjectBriefAnswer(payload)),
    onSuccess: () => {
      toast({
        title: 'Ответ сохранен',
      })

      queryClient.invalidateQueries({
        queryKey: briefAnswersQueryKey,
      })
    },
    onError: (error: Error) => {
      toast({
        title: 'Не удалось сохранить ответ',
        description: error.message,
        variant: 'destructive',
      })
    },
  })
}

export default useUpdateProjectBriefAnswer
